export default "__VITE_ASSET__DYHuTjxv__"